/* eslint-disable max-lines */
import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { MODAL_TRANSITION_DURATION, MODAL_Z_INDEX } from './tokens';
import { CFStyleThemes } from '../../theme';
//
// Tokens
//
export const CFBaseModalBottomSheetTokens = {
    BORDER_RADIUS: CFTokens.BORDER_RADIUS.D,
    MAX_WIDTH: 480,
    PADDING: {
        BLOCK: {
            BODY: CFTokens.SPACER.D,
            FOOTER: CFTokens.SPACER.B,
            HEADER: CFTokens.SPACER.B,
        },
        INLINE: CFTokens.SPACER.D,
    },
    SHADOW: CFTokens.ELEVATION.B,
};
//
// Helpers
//
export const CFBaseModalBottomSheetHelpers = {
    borderRadius: ({ variant }) => variant === 'toast'
        ? css `
          border-radius: ${CFBaseModalBottomSheetTokens.BORDER_RADIUS}px;
        `
        : css `
          border-top-left-radius: ${CFBaseModalBottomSheetTokens.BORDER_RADIUS}px;
          border-top-right-radius: ${CFBaseModalBottomSheetTokens.BORDER_RADIUS}px;
        `,
    height: ({ heightPreset = 'auto' }) => {
        switch (heightPreset) {
            case '1/3':
                return '33%';
            case '1/2':
                return '50%';
            case '2/3':
                return '67%';
            case 'full':
                return '100%';
            default:
                return 'auto';
        }
    },
    rootCSSTransitions: ({ transitionState, }) => {
        switch (transitionState) {
            case 'entering':
                return css `
          display: flex;
          transform: translateY(100%);
          opacity: 0;
        `;
            case 'entered':
                return css `
          transform: translateY(0);
          opacity: 1;
        `;
            case 'exiting':
                return css `
          transform: translateY(100%);
          opacity: 0;
        `;
            case 'exited':
                return css `
          display: none;
          transform: translateY(100%);
          opacity: 0;
        `;
        }
    },
    rootPadding: ({ footerSafeGap, headerSafeGap, variant, }) => {
        const bpad = variant === 'toast' ? CFTokens.SPACER.D + Number(footerSafeGap || 0) : 0;
        const lrpad = variant === 'toast' ? CFTokens.SPACER.D : 0;
        const tpad = CFTokens.SPACER.D + Number(headerSafeGap || 0);
        return css `
      padding: ${tpad}px ${lrpad}px ${bpad}px ${lrpad}px;
    `;
    },
    sheetBackgroundColor: ({ alternateTheme, theme, }) => {
        if (alternateTheme) {
            return theme
                ? theme.COLOR.MODAL_BACKGROUND_ALTERNATE
                : CFStyleThemes.DEFAULT.COLOR.MODAL_BACKGROUND_ALTERNATE;
        }
        return theme
            ? theme.COLOR.MODAL_BACKGROUND
            : CFStyleThemes.DEFAULT.COLOR.MODAL_BACKGROUND;
    },
    sheetPadding: ({ footerSafeGap, variant, }) => {
        if (variant === 'toast') {
            return css `
        padding: ${CFTokens.SPACER.B}px 0 ${CFTokens.SPACER.E}px;
      `;
        }
        const bottomPadding = footerSafeGap
            ? footerSafeGap || 0
            : CFTokens.SPACER.B;
        return css `
      padding: ${CFTokens.SPACER.B}px 0 ${bottomPadding}px 0;
    `;
    },
};
//
// Element Styles
//
export const CFBaseModalBottomSheetStyles = {
    Body: css `
    box-sizing: border-box;
    padding: ${CFBaseModalBottomSheetTokens.PADDING.BLOCK.BODY}px
      ${CFBaseModalBottomSheetTokens.PADDING.INLINE}px;
    width: 100%;
  `,
    Footer: css `
    box-sizing: border-box;
    padding: ${CFBaseModalBottomSheetTokens.PADDING.BLOCK.FOOTER}px
      ${CFBaseModalBottomSheetTokens.PADDING.INLINE}px;
    width: 100%;
  `,
    Header: css `
    box-sizing: border-box;
    padding: ${CFBaseModalBottomSheetTokens.PADDING.BLOCK.HEADER}px
      ${CFBaseModalBottomSheetTokens.PADDING.INLINE}px;
    width: 100%;
  `,
    Root: css `
    box-sizing: border-box;
    padding: 0;
    width: 100%;
    max-width: ${CFBaseModalBottomSheetTokens.MAX_WIDTH}px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
    z-index: ${MODAL_Z_INDEX};
    border: 0;
    background: transparent;
    ${CFBaseModalBottomSheetHelpers.rootPadding};
  `,
    RootNative: css `
    position: absolute;
    right: 0;
    top: 100%;
    left: 0;
  `,
    RootWeb: css `
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    transition-duration: ${MODAL_TRANSITION_DURATION}ms;
    transition-timing-function: ease-in-out;
    ${CFBaseModalBottomSheetHelpers.rootCSSTransitions}
  `,
    Sheet: css `
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    align-items: flex-start;
    justify-content: flex-start;
    overflow: hidden;
    gap: 0;
    position: relative;
    background-color: ${CFBaseModalBottomSheetHelpers.sheetBackgroundColor};
    box-shadow: ${CFBaseModalBottomSheetTokens.SHADOW};
    ${CFBaseModalBottomSheetHelpers.borderRadius};
    ${CFBaseModalBottomSheetHelpers.sheetPadding};
  `,
};
